var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.513,
    height: 31.513,
    viewBox: "0 0 31.513 31.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gift-2--reward-box-social-present-gift-media-rating-bow",
    transform: "translate(-2.679 -2.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.329,10.411c0-2.095-2.444-6.982-6.109-6.982-5.964,0-3.791,6.982-.937,6.982",
    transform: "translate(-1.893 0)",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24,10.411c0-2.095,2.444-6.982,6.109-6.982,5.964,0,3.791,6.982.937,6.982",
    transform: "translate(-5.565 0)",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2239",
    "data-name": "Vector 2239",
    d: "M24,39.007V24",
    transform: "translate(-5.565 -5.565)",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.3,36.406V23.631H5.911V36.406a2.5,2.5,0,0,0,2.5,2.5H29.8A2.5,2.5,0,0,0,32.3,36.406Z",
    transform: "translate(-0.672 -5.465)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.442,15.5v2.753a2.5,2.5,0,0,1-2.5,2.5H5.93a2.5,2.5,0,0,1-2.5-2.5V15.5A2.5,2.5,0,0,1,5.93,13H30.941a2.5,2.5,0,0,1,2.5,2.5Z",
    transform: "translate(0 -2.589)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.eabbce1e9b957671fb5db0a016ea4e21.svg";
export { ForwardRef as ReactComponent };